import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Hidden admin access: navigate to the admin portal via Ctrl+X (or Cmd+X)
// when not typing inside an input/textarea/contenteditable field.
const AdminAccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      const el = document.activeElement;
      const tag = (el?.tagName || '').toLowerCase();
      const isEditable = tag === 'input' || tag === 'textarea' || el?.isContentEditable;

      if ((e.ctrlKey || e.metaKey) && (e.key === 'x' || e.key === 'X') && !isEditable) {
        e.preventDefault();
        navigate('/portal-gsh');
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate]);

  return null;
};

export default AdminAccess;
